import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

const iconClass = 'w-5 h-5 text-gray-500 transition-colors group-hover:text-[--tb-primary]'

interface FileIconProps {
    fileName: string
}

const FileIcon = ({ fileName }: FileIconProps) => {
    const extension = fileName.split('.').pop()?.toLowerCase()

    if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(extension || '')) {
        return <DynamicFaIcon iconName='file-image' className={iconClass} />
    }
    if (['doc', 'docx'].includes(extension || '')) return <DynamicFaIcon iconName='file-word' className={iconClass} />
    if (['xls', 'xlsx'].includes(extension || '')) return <DynamicFaIcon iconName='file-excel' className={iconClass} />
    if (extension === 'pdf') return <DynamicFaIcon iconName='file-pdf' className={iconClass} />

    return <DynamicFaIcon iconName='file' className={iconClass} />
}

export default FileIcon
